import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react'
import * as Yup from 'yup';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Iletisim = () => {
    const { t } = useTranslation();
    const [isModalVisible, setModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [isLoading, setLoading] = useState(false);

    const validationSchema = Yup.object({
        isim: Yup.string().required(t('isim-gerekli')),
        soyisim: Yup.string().required(t('soyisim-gerekli')),
        email: Yup.string().email(t('gecerli-bir-email')).required(t('email-gerekli')),
        telefon: Yup.string().required(t('telefon-gerekli')),
        mesaj: Yup.string().required(t('mesaj-gerekli')),
    });

    const containerVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { opacity: 1, scale: 1, transition: { duration: 0.8, staggerChildren: 0.1 } },
       
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
      
    };

    const errorVariants = {
        hidden: { opacity: 0, x: -100 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setLoading(true);
        try {
            const response = await fetch('https://genesiscs.com.tr/genesis-contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            });
    
            const result = await response.text();
            console.log(result);
    
            setSubmitting(false);
            setLoading(false);
            setModalMessage(t('mesajiniz-basariyla-gonderildi'));
            resetForm();
            setModalVisible(true);
        } catch (error) {
            console.log(t('mesaj-gonderimi-basarisiz-oldu'), error);
            setSubmitting(false);
            setLoading(false);
            setModalMessage(t('mesaj-gonderiminde-bir-hata-olustu'));
            setModalVisible(true);
        }
    };

    return (
        <div className="w-full bg-red grid grid-cols-11 relative pt-20 calc-height content-start">

            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-9 z-50">
                <h2 className='text-genesisBlue text-45 mb-3'>{t('iletisim')}</h2>
            </div>



            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-7 z-50 pb-10  ">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6129.25184268155!2d29.088180019348194!3d41.03285801023352!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac8566fc83a83%3A0x28a7b3afc5a5feda!2seOfis%20-%20%C3%9Cmraniye%20Exen%20%C4%B0stanbul!5e1!3m2!1sen!2str!4v1734694267163!5m2!1sen!2str" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>



            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-9 z-50 pb-20    flex justify-between flex-col md:flex-row">


                <div className='mb-10 md:mb-0'>
                    <a href='#' target='_blank' className='block text-20 font-light mb-3 text-genesisBlue duration-300 hover:text-customGray2 cursor-pointer'>
                        Tantavi̇ Mah. Estergon Cad. Exen İstanbul F Blok
                        <br />
                        No: 24 F İç Kapi No: 29 Ümrani̇ye/  İstanbul
                    </a>


                    <a href='tel:+905318591156' target='_blank' className='block text-[#0E0E10] text-20  font-light duration-300 hover:text-customGray2 cursor-pointer'>+90 531 859 11 56</a>

                    <a href='mailto:info@genesiscs.com.tr' target='_blank' className='block text-[#0E0E10] text-20  font-light duration-300 hover:text-customGray2 cursor-pointer'>info@genesiscs.com.tr</a>
                </div>


 

            </div>


            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-9 z-50">
                <h2 className='text-genesisBlue text-30 mb-3'>{t('iletisim-formu')}</h2>
            </div>


            <div className='col-span-11 z-50 mb-20'>

                <motion.div className='z-50 relative' variants={containerVariants}>
                    <Formik
                        initialValues={{ isim: '', soyisim: '', email: '', telefon: '', mesaj: '' }}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, errors, touched }) => (
                            <Form className=''>
                                <div className="grid  grid-cols-11">
                                    <div className='col-start-2 col-span-9 md:col-start-2 md:col-span-7 grid md:grid-cols-2 gap-5 '>
                                        <div className='grid grid-rows-4 gap-2'>
                                            <motion.div variants={itemVariants} className='relative '>
                                                <Field name="isim" placeholder={t('isim')} type='text' className='w-full py-4 px-4 text-16 border' />
                                            </motion.div>
                                            <motion.div variants={itemVariants} className='relative '>
                                                <Field name="soyisim" placeholder={t('soyisim')} type='text' className='w-full py-4 px-4 text-16 border' />
                                            </motion.div>
                                            <motion.div variants={itemVariants} className='relative '>
                                                <Field name="email" placeholder={t('email')} type='email' className='w-full py-4 px-4 text-16 transition-all duration-300 border' />
                                            </motion.div>
                                            <motion.div variants={itemVariants} className='relative '>
                                                <Field name="telefon" placeholder={t('telefon')} type='text' className='w-full py-4 px-4 text-16 border' />
                                            </motion.div>
                                        </div>
                                        <div className='grid grid-rows-4 gap-2'>
                                            <motion.div className='row-span-3 ' variants={itemVariants}>
                                                <Field as="textarea" name="mesaj" placeholder={t('mesaj')} className='w-full h-full py-4 px-4 text-16 row-span-4 border' />
                                            </motion.div>
                                            <motion.div className='row-span-1 mt-5 md:mt-0' variants={itemVariants}>
                                                <button type="submit" disabled={isSubmitting} className='cursor-pointer w-full py-4 px-4 text-16 font-semibold text-white bg-genesisBlue hover:text-white hover:bg-misuraBlue flex justify-center items-center row-span-1 transition-all duration-300'>
                                                {t('gonder')}
                                                </button>
                                            </motion.div>
                                        </div>
                                    </div>

                                    <div className='col-start-2 col-span-9 md:col-span-2 py-2  px-0 md:p-4 text-red-600 text-xs font-light'>
                                        {Object.keys(errors).length > 0 && (
                                            <ul>
                                                {Object.keys(errors).map((key) => (
                                                    touched[key] && (
                                                        <motion.li
                                                            key={key}
                                                            initial="hidden"
                                                            animate="visible"
                                                     
                                                            variants={errorVariants}
                                                        >
                                                            {errors[key]}
                                                        </motion.li>
                                                    )
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </motion.div>

            </div>




             {isLoading && (
                <div className="absolute  top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <motion.div
                        className="flex flex-col items-center justify-center"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                
                    >

                     
                        <motion.p
                            className="text-white text-lg"
                            animate={{ opacity: [0.8, 1, 0.8] }}
                            transition={{ repeat: Infinity, duration: 2 }}
                        >
                            {t('mesajiniz-gonderiliyor...')}
                        </motion.p>
                    </motion.div>
                </div>
            )}


            {isModalVisible && (
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
              
                    className="absolute top-0 left-0 w-full h-full flex items-center justify-center  bg-[rgba(0,0,0,0.5)] z-50"
                >
                    <div className="bg-white p-8  shadow-lg text-center max-w-sm mx-auto">
                        <p className="mb-4 text-sm">{modalMessage}</p>
                        <button
                            onClick={() => setModalVisible(false)}
                            className="px-12 py-4 bg-genesisBlue text-white hover:bg-misuraBlue text-sm "
                        >
                             {t('tamam')}
                        </button>
                    </div>
                </motion.div>
            )}

        </div>
    );
}

export default Iletisim;
